define.alias("ember-math-helpers/helpers/ceil", "media/helpers/ceil");